import React, { useCallback, useEffect, useState } from 'react';
import img from '../assets/img/logo22.png'
import uc from '../assets/img/image_ucom.png'
import footer from '../assets/img/logo2.png'
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation, useNavigate } from "react-router-dom";
import NewspaperIcon from '@mui/icons-material/Newspaper';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import Cookies from 'js-cookie'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import Menu from "./Menu";
import LangPop from "./LangPop";
import { employee, input, login, menu } from "../translate";
import Account from "../helpers/Account";
import { useDispatch, useSelector } from "react-redux";
import { employeeIswebSet, moneyRequest, oggRequest, priceRequest, profileEmployeeRequest, profileRequest, profileUrsRequest } from "../store/actions/users";
import Money from "./Money";
import Api from "../Api";
import { Tooltip } from 'react-tooltip';
import ats from '../assets/img/logo_light.png'
import footer_img from '../assets/img/header_logo.svg'
import ats_footer from '../assets/img/voff_footer.png'
import Loader from "./Loader";
import { REACT_APP_API_URL } from '../config';
import NewsBanner from "./NewsBanner";
import AnnouncementIcon from '@mui/icons-material/Announcement';
import _ from 'lodash';
import NewsNumber from './NewsNumber';
import Chat from './Chat';
import { Switch, FormControlLabel, Tooltip as MuiTooltip } from '@mui/material';
import { toast } from 'react-toastify';
import HelpDeskPreviewDrawer from './HelpDeskPreviewDrawer';
import {
    getFirstAllowedRoute,
    hasHistoryView,
    hasOnlineView,
    hasEmployeeTelegram,
    hasEmployeeWhatsApp,
    isHistoryPath,
    isMessagingHistoryPath,
} from '../helpers/employeePermissions';

const { REACT_APP_SERVER } = process.env;
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

function Wrapper({ children }) {
    const [lang, setLang] = useState(0)
    const [open, setOpen] = useState(false)
    const [news, setNews] = useState([])
    const [isAside, setIsAside] = useState(false)
    const [loader, setLoader] = useState(true)
    const [scroll, setScroll] = useState([])
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const userData = useSelector((state) => state.users.userData)
    const money = useSelector((state) => state.users.money)
    const prices = useSelector((state) => state.users.prices)
    const ogg = useSelector((state) => state.users.ogg)
    const profile = useSelector(state => state.users.ursData)
    const employeeData = useSelector(state => state.users.employeeData)
    const fetchedEmployee = useSelector(state => state.users.fetchedEmployee)
    const authToken = Account.getAdminToken() || ''
    const [ask, setAsk] = useState(0);
    const [isAllowed, setIsAllowed] = useState(Cookies.get('isAllowed') === 'true');
    const [helpDeskPreviewOpen, setHelpDeskPreviewOpen] = useState(false);
    const [sipWebRtcSaving, setSipWebRtcSaving] = useState(false);
    let num = 0
    const openWindow = (e) => {
        e.preventDefault();
        window.open(
            "/online",
            "_blank",
            "width=600,height=300,noopener,noreferrer"
        );
    };
    useEffect(() => {
        if (+localStorage.getItem('atsLang')) {
            setLang(+localStorage.getItem('atsLang'))
        } else {
            localStorage.setItem('atsLang', '1')
        }

    }, [])

    useEffect(() => {
        (async () => {
            try {

                // if ((!sessionStorage.getItem('news') && userData.news) && !profile.id && !Cookies.get('viewer')) {
                //     const { data } = await Api.getNews()
                //     setNews(data.list)
                //     sessionStorage.setItem('news', '1')
                // }
            } catch (e) {
                console.log(e);

            }
        })()
    }, [userData, REACT_APP_SERVER, profile])

    const handleNews = useCallback(async () => {
        const { data } = await Api.getNews(0)
        setNews(data.list)
    }, [REACT_APP_SERVER])
    useEffect(() => {
        if (REACT_APP_SERVER === 'ATS') {
            document.body.style.backgroundImage = 'none'
            if (document.getElementsByTagName('header')[0]) {
                document.getElementsByTagName('header')[0].style.backgroundImage = 'none'
            }
            if (document.getElementsByTagName('footer')[0]) {
                document.getElementsByTagName('footer')[0].style.backgroundImage = 'none'
            }
        }
    }, [REACT_APP_SERVER])

    // Auth: use employeeData (from API /employee/profile) for role/permissions — server-authoritative. Cookies only decide which profile to fetch.
    useEffect(() => {
        (async () => {
            const token = Account.getAdminToken();
            const buddy = Cookies.get('buddy');
            const member = Cookies.get('member');
            const viewer = Cookies.get('viewer');
            const isNew = Cookies.get('new');

            if (buddy && String(buddy).length === 7 && !isNew) {
                window.location.href = `${REACT_APP_API_URL}/operators`;
                return;
            }
            if (!token) {
                navigate('/login');
                return;
            }

            try {
                if (member && !fetchedEmployee) {
                    await dispatch(profileEmployeeRequest());
                } else if (!buddy) {
                    await dispatch(profileRequest());
                }
                if (viewer) {
                    await dispatch(profileUrsRequest());
                }
            } catch (e) {
                console.error('Wrapper auth init:', e);
            }

            await dispatch(moneyRequest());
            await dispatch(priceRequest());
            await dispatch(oggRequest());
        })().finally(() => {
            if (!Cookies.get('buddy')) {
                setLoader(false);
            }
        });
    }, [authToken, fetchedEmployee]);

    useEffect(() => {
        (async () => {
            try {
                if (prices?.length && money?.mappedData?.length) {
                    let commonObjects = prices.filter(obj1 => money.mappedData.some(obj2 => obj2.name === obj1.sname));
                    let commonObjects1 = prices.filter(obj1 => !money.mappedData.some(obj2 => obj2.name === obj1.sname));
                    commonObjects = commonObjects.filter(l => l.sname !== 'CRMSTP' && l.sname !== 'MOB' && l.sname !== 'REC').map(l => ({
                        name: l.sname,
                        val: color,
                        percent: l.percent || 0
                    }))
                    commonObjects1 = commonObjects1.filter(l => l.sname !== 'CRMSTP' && l.sname !== 'MOB' && l.sname !== 'REC').map(l => ({
                        name: l.sname,
                        val: 'red',
                        percent: l.percent || 0
                    }));
                    setScroll([...commonObjects, ...commonObjects1])
                    num = 0
                    setLoader(false)
                } else if (prices?.length && !money?.mappedData?.length) {
                    setLoader(false)
                }
            } catch (e) {
                setLoader(false)

                console.log(e)
            }
        })()
    }, [money, prices])
   
   useEffect(() => {
        if (!employeeData?.buddy) return;
        const p = location.pathname || '';
        if (!hasHistoryView(employeeData) && isHistoryPath(p)) {
            navigate(getFirstAllowedRoute(employeeData), { replace: true });
            return;
        }
        if (!hasHistoryView(employeeData)) {
            if (p.startsWith('/history_telegram') && !hasEmployeeTelegram(employeeData)) {
                navigate(getFirstAllowedRoute(employeeData), { replace: true });
                return;
            }
            if (p.startsWith('/history_whatsapp') && !hasEmployeeWhatsApp(employeeData)) {
                navigate(getFirstAllowedRoute(employeeData), { replace: true });
                return;
            }
        }
        if (!hasOnlineView(employeeData) && (p === '/online' || p.startsWith('/online/'))) {
            navigate(getFirstAllowedRoute(employeeData), { replace: true });
            return;
        }
        if (employeeData.permission) return;
        const allowedForBuddyNoRole =
            isMessagingHistoryPath(p) ||
            p === '/profile' ||
            p === '/online';
        if (!allowedForBuddyNoRole) {
            navigate(hasHistoryView(employeeData) ? '/history' : getFirstAllowedRoute(employeeData));
        }
    }, [employeeData?.buddy, employeeData?.permission, location.pathname, navigate]);

    const handleEmployeeWebrtcToggle = useCallback(async (checked, type) => {
        if (!employeeData?.buddy) return;
        setSipWebRtcSaving(true);
        try {
            await Api.employeeWebrtc({
                isWeb: checked ? 1 : 0,
                buddy: employeeData.buddy,
                token: Account.getAdminToken(),
            });
            dispatch(employeeIswebSet(checked ? 1 : 0));
            if(type === "logout"){
                navigate('/login')
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err?.message || 'Request failed');
        } finally {
            setSipWebRtcSaving(false);
        }
    }, [dispatch, employeeData?.buddy]);

    const showTopRightStripSwitch = REACT_APP_SERVER !== 'Beeline' && (!!employeeData?.buddy || !!localStorage.getItem('access_token_urs'));

    return (
        <>
            <header className="header">
                <div className="header_container container" style={window.innerWidth > 1030 ? {} : { maxWidth: '100%' }}>
                    <div className="header_block">
                        <div className="left">
                            <Link to={Cookies.get('viewer') ? '/urs' : "/"}>
                                {REACT_APP_SERVER === 'Beeline' ? <figure className="justify-content-end">

                                    <img src={img} style={window.innerWidth > 565 ? { width: 100 } : { width: 80 }} alt='' />
                                </figure> : REACT_APP_SERVER === 'ATS' ? <figure>

                                    <img src={ats} style={window.innerWidth > 565 ? { width: 120 } : { width: 80 }} alt='' />
                                </figure> : <figure>

                                    <img src={uc} alt='' style={window.innerWidth > 565 ? {} : { width: 110 }} />
                                    <figcaption className="v_office">V-office</figcaption>
                                </figure>}
                            </Link>
                            <div className="header_border" />
                            {!employeeData?.buddy ? window.innerWidth > 565 ? <>
                                <div className="header_food">
                                    <Link to='/clgroup' className="truncate"> {userData?.fio}</Link>
                                    <p>Inn: {userData?.phone}</p>
                                </div>

                                {!employeeData?.buddy ? <div className="header_border" /> : null}
                            </>
                                : null : <div className="header_food">
                                <Link to={hasHistoryView(employeeData) ? '/history' : getFirstAllowedRoute(employeeData)} className="truncate"> {userData?.fio}</Link>
                                <p>Inn: {userData?.phone}</p>
                            </div> }
                            {!employeeData?.buddy ? <div className="header_balance">
                                <div onClick={() => setOpen(true)}>
                                    {menu.amount[lang || 1]}
                                </div>
                                <p>
                                    {+userData?.gumar || 0} amd
                                </p>
                            </div> : null}


                            <div className="header_border" />
                            {window.innerWidth > 1030 && hasOnlineView(employeeData) ? <>
                                <div className="header_Finance">
                                    <Link
                                        to="/online"
                                        onClick={openWindow}
                                    ><AccessTimeFilledIcon
                                            sx={{ color: '#F28E2C', fontSize: 20 }} /> {menu.online[lang || 1]}</Link>
                                </div>
                                <div className="header_border" />
                            </>
                                : null}
                            {window.innerWidth > 1030 && hasHistoryView(employeeData) ?
                                <>
                                    <div className="header_Finance">
                                        <Link to="/history"><NewspaperIcon
                                            sx={{ color: 'orangered', fontSize: 20 }} /> {menu.history[lang || 1]}</Link>
                                    </div>
                                    <div className="header_border" />

                                </>
                                : null}

                            {window.innerWidth > 1250 ?
                                <>
                                    <div className="header_Finance">
                                        <span onClick={() => setHelpDeskPreviewOpen(true)} style={{ cursor: 'pointer' }}><AnnouncementIcon
                                                sx={{ color: '#36ad4a', fontSize: 20 }} /> {menu.helpdesk[lang || 1]}</span>
                                    </div>
                                    <div className="header_border" />

                                </>
                                : null}

                            {/*{window.innerWidth > 1250 ? <div className="header_Finance">*/}
                            {/*    <span><ContactEmergencyIcon sx={{color: '#CE405F', fontSize: 20}}/> Պատմություն</span>*/}
                            {/*</div> : null}*/}

                        </div>
                        <div className="right">
                            {/*{window.innerWidth > 565 && userData.id === 1 && REACT_APP_SERVER === 'Beeline' ? <div className="profile">*/}
                            {/*    <Link to='/crm_integration' style={{marginRight:5,}}><AccountCircleIcon*/}
                            {/*        sx={{color: '#2cf2eb', fontSize: 20}}/> {sip.crm[lang]}</Link>*/}
                            {/*</div> : null}*/}

                            {employeeData?.buddy ? null : window.innerWidth > 565 ? <div className="profile">
                                <Link to='/profile'><AccountCircleIcon
                                    sx={{ color: '#F28E2C', fontSize: 20 }} /> {menu.profile[lang || 1]}</Link>
                            </div> : null}

                            {window.innerWidth > 1250 ? <div className="logout" onClick={() => employeeData?.buddy ? handleEmployeeWebrtcToggle(0,"logout"): navigate('/login')}>
                                <Link><LockIcon sx={{ color: '#CD405F', fontSize: 20 }} /> {menu.logout[lang || 1]}
                                </Link>
                            </div> : null}

                            {window.innerWidth < 1250 ?
                                <div onClick={() => setIsAside(!isAside)} style={{ margin: '0 10px' }}
                                    className="d-flex align-items-center justify-content-center">
                                    <MenuIcon />
                                </div> : null}
                        </div>

                    </div>
                </div>
            </header>
            {showTopRightStripSwitch ? (
                <div style={{
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 40,
                    top: 95,
                    right: 0,
                    paddingRight: 8,
                    paddingLeft: 8,
                    paddingTop: 4,
                    paddingBottom: 4,
                }}>
                    {employeeData?.buddy ? (
                        <MuiTooltip title={employee.webrtc_label[lang || 1]}>
                            <span style={{ display: 'inline-flex', alignItems: 'center', maxWidth: 'min(92vw, 420px)' }}>
                                <FormControlLabel
                                    sx={{
                                        margin: 0,
                                        gap: 0.75,
                                        alignItems: 'center',
                                        '& .MuiFormControlLabel-label': { fontSize: 14, color: '#111', whiteSpace: 'nowrap' },
                                    }}
                                    control={(
                                        <Switch
                                            color="success"
                                            size="small"
                                            disabled={sipWebRtcSaving}
                                            checked={!!employeeData?.isweb}
                                            onChange={(e) => handleEmployeeWebrtcToggle(e.target.checked)}
                                        />
                                    )}
                                    label={employee.receive_calls_here[lang || 1]}
                                />
                            </span>
                        </MuiTooltip>
                    ) : (
                        <FormControlLabel
                            control={(
                                <Switch
                                    color="success"
                                    checked={isAllowed}
                                    onChange={(e) => {
                                        const value = e.target.checked;
                                        setIsAllowed(value);
                                        Cookies.set('isAllowed', value ? 'true' : 'false', { expires: 30 });
                                    }}
                                />
                            )}
                        />
                    )}
                </div>
            ) : null}
            <main className={window.location.pathname === '/files' ? "main container" : 'main container'} style={window.innerWidth > 1030 ? { marginTop: showTopRightStripSwitch ? 55 : 0 } : { maxWidth: '100%', marginTop: showTopRightStripSwitch ? 55 : 0 }}>
                {_.isEmpty(profile) && window.innerWidth > 585 && !employeeData?.buddy ? loader ? <div className="loaderContainer"><Loader /></div> :
                    <div style={{ width: '100%', marginTop: 20, height: 45 }}
                        className="d-flex flex-row align-items-center position-relative">
                        <span
                            data-tooltip-content={ogg[lang - 1 || 0]}
                            className="d-flex flex-row align-items-center justify-content-center"
                            style={{
                                display: 'inline-block',
                                paddingLeft: 5,
                                color: 'black',
                                cursor: 'pointer',
                                fontWeight: 700,
                                textAlign: 'center'
                            }}
                            data-tooltip-id="my-tooltip"
                        >{ogg[lang - 1 || 0]?.split(' ').map(item => item.charAt(0).toUpperCase()).join('')}</span>
                        {scroll.map((el, _) => {
                            if (el.val !== 'red') {
                                num += el.percent
                            }
                            if (scroll[_ + 1] && scroll[_ + 1].val === 'red' && scroll[_].val === color && _ !== scroll?.length - 1 && num !== 100) {
                                return (
                                    <div style={{ left: `calc(${num}% - 25px)` }}
                                        className="d-flex flex-row align-items-center position-relative" key={el.name}>
                                        <span
                                            className="d-flex flex-row align-items-center justify-content-center"
                                            style={{
                                                border: '5px solid #fff',
                                                fontSize: 15,
                                                boxShadow: '0px 0px 7px 0px #00000054',
                                                background: el.val,
                                                display: 'inline-block',
                                                width: 50,
                                                height: 50,
                                                borderRadius: '100%',
                                                color: 'white'

                                            }}
                                            data-tooltip-id="my-tooltip"
                                        >
                                            {num}%
                                        </span>
                                    </div>
                                )
                            }

                        })}
                        <span
                            className="d-flex flex-row align-items-center justify-content-center position-absolute"
                            style={{
                                border: window.innerWidth <= 320 ? '1px solid #fff' : '5px solid #fff',
                                fontSize: window.innerWidth <= 320 ? 8 : 15,
                                boxShadow: '0px 0px 7px 0px #00000054',
                                background: scroll[scroll?.length - 1]?.val !== 'red' || num === 100 ? color : '#ccc',
                                display: 'inline-block',
                                width: window.innerWidth <= 320 ? 20 : 50,
                                height: window.innerWidth <= 320 ? 20 : 50,
                                borderRadius: '100%',
                                color: 'white',
                                right: 0,
                                textAlign: 'center',
                            }}
                            data-tooltip-id="my-tooltip"
                        >100%</span>
                        <span style={{
                            width: 'calc(100% - 45px)',
                            height: '15px',
                            display: 'inline-block',
                            background: num === 0 ? "white" : `linear-gradient(to right, ${color} ${num}%, white ${num + 10}%)`,
                            boxShadow: '4px 0px 7px 0px #00000054',
                            position: 'absolute',
                            zIndex: -1,
                            right: 0
                        }} />
                    </div> : null}
                <Tooltip id="my-tooltip" />
                <div className="main_container" style={{ minHeight: '90vh' }}>
                    <Menu isAside={isAside} lang={lang || 1} />  
                    <div
                        className={`table_content${location.pathname === '/files' ? ' table_content_files' : ''}${location.pathname === '/history' || location.pathname === '/graphic' || location.pathname.startsWith('/history_telegram') || location.pathname.startsWith('/operator_report') ? ' table_content_history' : ''}`}
                        style={window.location.pathname !== '/new-online' && window.location.pathname !== '/history' && window.location.pathname !== '/graphic' && !window.location.pathname.includes('/history_telegram') && !window.location.pathname.includes('/operator_report') && !window.location.pathname.includes('/history_whatsapp') && window.innerWidth > 1030 ? { width: '76%' } : { width: '100%', paddingLeft: 2, paddingRight: 2 }}>
                        {children}
                    </div>
                </div>
            </main>
            <footer className="footer">
                <div className="footer_container container">
                    <div className="row">
                        <figure className="col-md-4">
                            <img style={REACT_APP_SERVER === 'ATS' ? { height: '79%' } : {}}
                                src={REACT_APP_SERVER === 'ATS' ? footer_img : ats_footer} alt="" />
                        </figure>
                        <div style={{ cursor: 'pointer', }} className="col-md-4  languages">
                            <LangPop setLang={setLang} />
                        </div>
                        <div className="col-md-4 d-flex align-items-center justify-content-center">
                            <div className="d-flex align-items-start justify-content-center flex-column"
                                style={{ minHeight: 80 }}>
                                <p style={{ margin: 0 }}><b>{input.phone[lang || 1]}:</b> +37444720101, +37411720101</p>
                                <p style={{ margin: 0 }}><b>{input.email[lang || 1]}:</b> info@ats.am
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
                
                {open ? <Money open={open} setOpen={setOpen} /> : null}
                {news.length ? <NewsBanner setAsk={setAsk} open={news} list={news} setOpen={setNews} /> : null}
                {ask ? <NewsNumber open={ask} setNews={setNews} setOpen={setAsk} /> : null}
                <HelpDeskPreviewDrawer open={helpDeskPreviewOpen} onClose={() => setHelpDeskPreviewOpen(false)} />
            </footer>

        </>
    );
}

export default Wrapper;
